import React, { useEffect, useState } from "react";
import { Empty } from "antd";
import "./index.scss";

const StationProcess = ({ data = {} }) => {
  return (
    <div
      className="flowUnitProcess"
      style={{
        width: data.canvasWidth,
        height: data.canvasHeight,
        backgroundImage: `url(${data.canvasBg})`,
      }}
    >
      {data.processFlowDeviceDiyDTOList &&
        data.processFlowDeviceDiyDTOList.map((item) => {
          return (
            <div
              className="custom-html"
              key={item.id}
              style={{
                position: "absolute",
                width: item.width,
                height: item.height,
                left: item.posX,
                top: item.posY,
              }}
            >
              {item.isShowName == 1 && <div className="h">{item.attrName}</div>}
              {item.type == 1 && (
                <div className={item.value == 1 ? "v success" : "v error"}>
                  {item.value == 1 ? "启动" : "停止"}
                </div>
              )}
              {item.type == 2 && (
                <div className="v" style={{ transform: "scale(0.9)" }}>
                  {item.value + item.unit}
                </div>
              )}
              {item.type == 3 && (
                <div className="v" style={{ transform: "scale(0.9)" }}>
                  {item.value}
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};

export default StationProcess;
